import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { Button } from '@openx/components-core/lib/Button/Button';
import { useTranslation } from 'react-i18next';

type DealPromptErrorAlertProps = {
  onRetry: () => void;
};

export const DealPromptErrorAlert = ({ onRetry }: DealPromptErrorAlertProps) => {
  const { t } = useTranslation();

  return (
    <Alert
      severity="error"
      sx={{ width: '100%', maxWidth: 906, alignSelf: 'center', mt: -2.5 }}
      data-test="deal-prompt-error-alert"
    >
      <Typography variant="h3">{t("We couldn't process your prompt")}</Typography>

      <Typography>{t('Something went wrong while processing your prompt. Please try again.')}</Typography>

      <Button onClick={onRetry} sx={{ mt: 1.5 }}>
        {t('Retry')}
      </Button>
    </Alert>
  );
};
